import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { graphql } from "gatsby";
import "../data/sections-fragment";
export const query = graphql`
  query {
    mdx(slug: { eq: "impressum" }) {
      slug
      frontmatter {
        title
        footer {
          showContactFooter: show_contact_footer
          showContactColumn: show_contact_column
        }
        backgrounds {
          ...BackgroundFragment
        }
        sections {
          ...MdxFrontmatterSectionsFields
        }
      }
    }
  }
`;
export const _frontmatter = {
  "title": "Impressum",
  "backgrounds": [{
    "rows": "1 / 2",
    "gradient": "linear-gradient(to-b, gray.50, rgba(255,255,255,0))",
    "spacing": {
      "top": ["24vh", null, "26vh", null, "33vh"]
    }
  }],
  "sections": [{
    "type": "plain",
    "slug": "impressum",
    "title": "Impressum",
    "spacing": {
      "top": ["12", null, "16", null, "24"],
      "bottom": ["40", null, "72"]
    },
    "textCol1": "#### Angaben gemäß § 5 TMG:\n\n<br />\nKienzler Betontechnik<br />\nGaragen GmbH & Co. KG\n\n##### Adresse\n\nZiegelhofstraße 35a<br />\n79110 Freiburg\n\n##### Telefon\n\n0761 898 284 04\n\n##### E-Mail\n\ninfo@kienzler-betontechnik.de\n\n##### Sitz\n\nFreiburg\n\n##### Registergericht\n\nAmtsgericht Freiburg\n\n##### Registernummer\n\nHRA 704233\n\n##### USt-Id-Nr.\n\nDE228971953\n\n<br />\n\n##### Persönlich haftende Gesellschafterin\n\nMarkus Kienzler Verwaltungs-GmbH\n\n##### Sitz\n\nFreiburg\n\n##### Registergericht\n\nAmtsgericht Freiburg\n\n##### Registernummer\n\nHRB 713216\n\n##### Geschäftsführer\n\nFlorian Kienzler\n\n<br />\n\n#### Konzept, Gestaltung, Programmierung\n\n[<ShiftBy y=\"2px\" display=\"inline-block\">Format</ShiftBy> <ArrowBoldIcon ml={1} mr={1} /> <ShiftBy y=\"2px\" display=\"inline-block\">Büro für Gestaltung</ShiftBy>](https://www​.for​mat​for​mat​.de)\n\n<br />",
    "textCol2": "#### Haftung für Inhalte\n\nDie Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.\n\n#### Haftung für Links\n\nUnser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.\n\n#### Urheberrecht\n\nDie durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen."
  }]
};
const layoutProps = {
  query,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      